<template>
  <div class="activity-enroll-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" class="top-title" title="活动报名" :showBack="true"></my-header>
    <div class="activity-detail-part">
      <div class="activity-box">
        <div class="activity-info-row">
          <div class="title">活动标题：</div><div class="content">{{activityDetail.title}}</div>
        </div>
        <div v-if="activityDetail.address" class="activity-info-row">
          <div class="title">活动地点：</div><div class="content">{{activityDetail.address}}</div>
        </div>
        <div class="activity-info-row">
          <div class="title">活动时间：</div><div class="content">{{activityDetail.activityDay}}</div>
        </div>
      </div>
    </div>
    <div class="activity-enroll-form">
      <div class="input-group">
        <div class="input-title">姓名</div>
        <input class="mint-field-core form-input" type="text" v-model="contactName" placeholder="请输入您的姓名">
      </div>
      <div class="input-group">
        <div class="input-title">联系电话</div>
        <input class="mint-field-core form-input" type="number" v-model="contactPhone" placeholder="请输入您的联系电话">
      </div>
      <div v-if="activityType =='3'" class="input-group">
        <div class="input-title">报名人数</div>
        <input class="mint-field-core form-input" type="number" v-model="enrollNum" placeholder="请输入报名人数">
      </div>
      <div v-if="activityType =='3'" class="input-group">
        <div class="input-title">微信号</div>
        <input class="mint-field-core form-input" type="text" v-model="wechat" placeholder="请输入您的微信号(非必填)">
      </div>
      <div class="input-group">
        <div class="input-title">小区名称</div>
        <input class="mint-field-core form-input" type="text" v-model="village" placeholder="请输入您的小区名称(非必填)">
      </div>
      <div v-if="activityType =='1'" class="input-group">
        <div class="input-title">拟购商品</div>
        <input class="mint-field-core form-input" type="text" v-model="intend" placeholder="请输入您想购买的商品(非必填)">
      </div>
      <div v-if="activityType =='1'" class="input-group">
        <div class="input-title">水木社区ID</div>
        <input class="mint-field-core form-input" type="text" v-model="newsmthAccount" placeholder="请输入您在水木社区的ID(非必填)">
      </div>
      <div class="form-btn" @click="enrollSave" >立即报名</div>
    </div>
    <div v-if="isEnroll" class="toast general-trade-modal general-box-shadow">
      <div class="general-trade-modal-text">您已报名参加该活动!</div>
      <div class="confirm-footer tip-footer">
        <div class="agree-btn" @click="confirm">确定</div>
      </div>
    </div>
    <div v-if="isEnroll" class="general-box-bg"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import activityService from '../../service/activity/ActivityService'
  import {imgUrl,shareIcon} from "../../config";
  import shareService from '../../service/share/ShareService';
  import session from '../../utils/Session'

  export default {
    name: 'ActivityEnroll',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        activityTitle:'',
        activityId:'',
        shareIcon:shareIcon,
        activityDetail:{},
        isEnroll:false,
        contactName:'',
        contactPhone:'',
        village:'',
        intend:'',
        enrollNum:'',
        wechat:'',
        newsmthAccount:'',
        isWechatBrowser:this.$verfyBrowserType(),
        activityType:'1'
      }
    },
    created(){
      this.activityId = this.$route.query.activityId;
      this.loadActivityDetail();
    },
    beforeMount () {
      document.title = this.$route.meta.title;
    },
    methods: {
      async loadActivityDetail(){
        let {code,msg,data} = await activityService.detail(this.activityId);
        if(code == '0'){
          this.activityDetail = data;
          this.activityType = data.type;
          this.initWechatShare();
        }else {
          Toast(msg);
        }
      },
      async enrollSave(){
        if(!this.contactName){
          Toast('请输入您的姓名!');
          return ;
        }
        if(this.contactPhone){
          var re= /^1[34578]\d{9}$/;
          if(!re.test(this.contactPhone)){
            Toast('您的联系电话格式不正确!');
            return ;
          }
        }else {
          Toast('请输入您的联系电话!');
          return ;
        }
        if(!this.enrollNum && this.activityDetail.type == '3'){
          Toast('请输入报名人数!');
          return ;
        }

        if(this.activityDetail.type == '3' && !(eval(this.enrollNum)>eval(0))){
          Toast('请输入大于0的报名人数!');
          return ;
        }

        let {code,msg,} = await activityService.enrollSave(this.activityId,this.contactName,this.contactPhone,this.village,this.intend,this.newsmthAccount,this.enrollNum,this.wechat);
        if(code == '0'){
          Toast('您已成功报名该活动!');
          this.$router.go(-1);
        }else {
          Toast(msg);
        }
      },
      confirm(){
        this.isEnroll = false;
      },
      async initWechatShare(){
        let title = this.activityTitle + '报名入口';// 分享标题
        let desc = ""; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#')
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .activity-enroll-page {
    font-size: 0.32rem;
    text-align: left;
    margin-bottom: 0.5rem;
    padding-top: 0.3rem;
    background-color: white;
    .activity-detail-part{
      width: 6.9rem;
      margin: 0 auto;
      color: #1b1e29;
      background-color: white;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
		  rgba(0, 0, 0, 0.1);
	    border-radius: 0.08rem;
      .activity-box{
        padding-top:0.31rem;
        padding-bottom:0.45rem;
      }
      .activity-info-row{
        margin-bottom: 0.3rem;
        display:flex;
        width: 6.9rem;
        line-height: 0.42rem;
        .title{
          margin-left: 0.2rem;
	        font-size: 0.28rem;
          color: #7f7d7c;;
          width: 1.5rem;
        }
        .content{
        	font-size: 0.32rem;
          width: 5.5rem;
          color: #191818;
          line-height: 0.38rem;
        }
      }
    }
    .activity-enroll-form{
      background: white;
      width: 6.9rem;
      margin: 0.42rem auto 0 auto;
      padding-bottom: 2rem;
       .form-btn{
          width: 2.80rem;
        	height: 0.8rem;
        	background-color: #feac00;
          border-radius: 0.4rem;
          font-size: 0.36rem;
          color: #ffffff;
          line-height: 0.9rem;
          margin-top: 0.6rem;
          letter-spacing: 0.05rem;
        }
      .input-group{
        width: 6.9rem;
        height: 1.1rem;
        margin-left: 0;
        margin-right: 0;
        padding-bottom: 0.1rem;
        text-align: left;
        position: relative;
        flex-direction: column;
        .input-title{
          margin-bottom: 0rem;
          font-size: 0.28rem;
          color: #7f7d7c;
          width: 6.9rem;
          margin-left: 0.1rem;
        }
        .form-input{
          width: 6.6rem;
          padding-left: 0rem;
          line-height: 0.53rem;
          font-size: 0.32rem;
          color: #cecbca;
          background-color: white;
          border-bottom: 0.01rem solid #e0dedc;
        }
        .mint-field-core{
          margin-left: 0.1rem;
        }
      }
    }
    .tip-footer{
      justify-content: flex-end
    }
  }
</style>
